import ClearIcon from '@mui/icons-material/ClearOutlined';
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  LinearProgress,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useSWRConfig } from 'swr';
import AxiosConfig from '../../../../config/AxiosConfig';
import TicketStatusChip from '../../utils/common/TicketStatusChip';
import UserAssignmentAutocomplete from '../../utils/common/UserAssignmentAutocomplete';
import DashboardSCTicketTableMenu from './DashboardSCTicketTableMenu.jsx';

const headers = [
  {
    id: 'reference',
    align: 'left',
    label: 'Référence',
  },
  {
    id: 'status',
    align: 'left',
    label: 'Status',
  },
  {
    id: 'order',
    align: 'left',
    label: 'N° Commande',
  },
  {
    id: 'contact',
    align: 'left',
    label: 'Contact',
  },
  {
    id: 'store',
    align: 'left',
    label: 'Store',
  },
  // {
  //   id: "categorization",
  //   align: "left",
  //   label: "Catégorie",
  // },
  // {
  //   id: "priority",
  //   align: "left",
  //   label: "Priorité",
  // },
  {
    id: 'messages',
    align: 'left',
    label: 'Message(s)',
  },
  {
    id: 'lastMessageAt',
    align: 'left',
    label: 'Dernier message',
  },
  {
    id: 'snippet',
    align: 'left',
    label: 'Snippet',
  },
  {
    id: 'assignedTo',
    align: 'center',
    label: 'Assignation',
  },
  {
    id: 'actions',
    align: 'right',
    label: '',
  },
];

const DashboardSCTicketTableToolbar = (props) => {
  const {
    loading,
    validating,
    service,
    titleIcon,
    dashboardData,
    setIsClose,
    setToModerate,
    setSellerType,
    setOrderRef,
    setAssignedUserTicket,
    nb,
  } = props;

  const [_userName, setUserName] = useState('');
  const [selectedUser, setSelectedUser] = useState(
    dashboardData?.assignedUserTicket
  );

  useEffect(() => {
    if (selectedUser) {
      setAssignedUserTicket(selectedUser);
    } else if (selectedUser === '') {
      setAssignedUserTicket('');
    } else {
      setAssignedUserTicket(null);
    }
  }, [selectedUser]);

  const handleAssignedUserCheckbox = (_e) => {
    if (dashboardData?.assignedUserTicket === null) {
      setAssignedUserTicket('');
    } else {
      setAssignedUserTicket(null);
      setUserName('');
      setSelectedUser(null);
    }
  };

  const handleIsCloseCheckbox = (_e) => {
    setIsClose(!dashboardData?.isClose);
  };

  const handleToModerateCheckbox = (e) => {
    setToModerate(!dashboardData?.toModerate);
    if (e.target.checked === true) {
      setIsClose(false);
      setAssignedUserTicket(null);
      setOrderRef(null);
      setSellerType(null);
    }
  };

  const handleSellerTypeCheckbox = (_e) => {
    if (dashboardData?.sellerType === null) {
      setSellerType(true);
    }
    if (dashboardData?.sellerType === true) {
      setSellerType(false);
    }
    if (dashboardData?.sellerType === false) {
      setSellerType(null);
    }
  };

  const handleOrderRefCheckbox = (_e) => {
    setOrderRef(dashboardData?.orderRef === null ? '' : null);
  };

  const handleOrderRefChange = (e) => {
    setOrderRef(e.target.value);
  };

  const handleOrderRefClear = (_e) => {
    setOrderRef('');
  };

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      {titleIcon}
      <Typography
        component={'span'}
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
      >
        Tickets :{' '}
        {loading || validating ? (
          <CircularProgress color="info" size={'0.8em'} />
        ) : (
          nb
        )}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          whiteSpace: 'nowrap',
          justifyContent: 'space-around',
          width: '100%',
        }}
      >
        {dashboardData?.sellerType !== undefined &&
        dashboardData?.service !== 'MP' ? (
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={dashboardData?.sellerType === true}
                  indeterminate={dashboardData?.sellerType === false}
                  onChange={handleSellerTypeCheckbox}
                  disabled={dashboardData?.toModerate || service === 'MP'}
                />
              }
              label={
                dashboardData?.sellerType === true
                  ? 'Marketplace seulement'
                  : dashboardData?.sellerType === false
                    ? 'Hoortrade seulement'
                    : 'Tout revendeur'
              }
            />
          </FormGroup>
        ) : null}
        {dashboardData?.toModerate !== undefined &&
        dashboardData?.service !== 'MP' ? (
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={dashboardData?.toModerate}
                  onChange={handleToModerateCheckbox}
                  disabled={service === 'MP'}
                />
              }
              label="Modération"
            />
          </FormGroup>
        ) : null}
        {dashboardData?.assignedUserTicket !== undefined &&
        dashboardData?.service !== 'MP' ? (
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={
                    dashboardData?.assignedUserTicket !== undefined &&
                    dashboardData?.assignedUserTicket !== null
                  }
                  disabled={dashboardData?.toModerate || service === 'MP'}
                  onChange={handleAssignedUserCheckbox}
                />
              }
              label="Assigné à"
            />
            {dashboardData?.assignedUserTicket !== undefined &&
            dashboardData?.assignedUserTicket !== null ? (
              <>
                <UserAssignmentAutocomplete
                  type={'ticket'}
                  setSelectedUser={setSelectedUser}
                  selectedUser={selectedUser}
                  isSubmit={true}
                />
              </>
            ) : null}
          </FormGroup>
        ) : null}
        {dashboardData?.isClose !== undefined &&
        dashboardData?.service !== 'MP' ? (
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={!!dashboardData?.isClose}
                  disabled={dashboardData?.toModerate || service === 'MP'}
                  onChange={handleIsCloseCheckbox}
                />
              }
              label="Fermé"
            />
          </FormGroup>
        ) : null}
        {dashboardData?.orderRef !== undefined &&
        dashboardData?.service !== 'MP' ? (
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={
                    dashboardData?.orderRef !== undefined &&
                    dashboardData?.orderRef !== null
                  }
                  disabled={dashboardData?.toModerate || service === 'MP'}
                  onChange={handleOrderRefCheckbox}
                />
              }
              label="Numéro de commande"
            />
            {dashboardData?.orderRef !== undefined &&
            dashboardData?.orderRef !== null ? (
              <TextField
                placeholder="Ref. Commande"
                onChange={handleOrderRefChange}
                value={dashboardData?.orderRef}
                variant="outlined"
                size="small"
                slotProps={{
                  input: {
                    type: 'text',
                    style: { fontSize: 12 },
                    endAdornment: (
                      <IconButton onClick={handleOrderRefClear} edge="end">
                        <ClearIcon />
                      </IconButton>
                    ),
                  },
                }}
              />
            ) : null}
          </FormGroup>
        ) : null}
      </Box>
    </Toolbar>
  );
};

const DashboardSCTicketTableHead = (props) => {
  const { dashboardData, setOrderBy, setOrder } = props;

  const handleChangeOrder = (orderBy) => {
    if (dashboardData?.orderBy === orderBy) {
      switch (dashboardData?.order) {
        case 'asc':
          setOrder('desc');
          break;
        case 'desc':
          setOrderBy(null);
          break;
        default:
          setOrder('asc');
      }
    } else {
      setOrderBy(orderBy);
      setOrder('asc');
    }
  };

  return (
    <TableHead sx={{ whiteSpace: 'nowrap' }}>
      <TableRow>
        {headers?.map((header) => (
          <TableCell
            key={header?.id}
            align={header?.align}
            sortDirection={
              dashboardData?.orderBy === header?.id
                ? dashboardData?.order
                : false
            }
          >
            {header?.id === 'status' || header?.id === 'lastMessageAt' ? (
              <>
                <TableSortLabel
                  active={dashboardData?.orderBy === header?.id}
                  direction={
                    dashboardData?.orderBy === header?.id
                      ? dashboardData?.order
                      : 'asc'
                  }
                  onClick={(_e) => handleChangeOrder(header?.id)}
                >
                  {header?.label}
                  {dashboardData?.orderBy === header?.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {dashboardData?.order
                        ? dashboardData?.order === 'desc'
                          ? 'sorted descending'
                          : 'sorted ascending'
                        : null}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </>
            ) : (
              <>{header?.label}</>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
const DashboardSCTicketRow = ({ ticket, service, mutate }) => {
  const navigate = useNavigate();
  const profile = useSelector((state) => state?.login?.profile);
  const [selectedUser, setSelectedUser] = useState(ticket?.assignedTo || null);
  const [isLoading, setIsLoading] = useState(false);
  const [
    shouldOpenTicketModerationDialog,
    setShouldOpenTicketModerationDialog,
  ] = useState(false);
  const { mutate: mutateUsers } = useSWRConfig();
  const { mutate: mutateTicket } = useSWRConfig();
  useEffect(() => {
    if (selectedUser?._id != ticket?.assignedTo?._id) {
      setIsLoading(true);
      AxiosConfig.create('post', `/tickets/${ticket?._id}/assignUser`)
        .call({
          assignedBy: profile?._id,
          assignedTo: selectedUser?._id,
        })
        .exit((_res) => {
          mutateUsers(`/users/`);
          mutateTicket(`/tickets/`);
          mutate();
          setIsLoading(false);
        })
        .catch((err) => console.error(err));
    } else {
      setIsLoading(false);
    }
  }, [selectedUser]);
  const handleNavigateToProject = (projectId, ticketId) => {
    navigate(`/project/${projectId}/tickets/${ticketId}/activities`);
  };
  const handleOpenTicketModerationDialog = () => {
    setShouldOpenTicketModerationDialog((state) => !state);
  };
  return (
    <TableRow
      hover
      tabIndex={-1}
      sx={{ cursor: 'pointer' }}
      value={ticket?._id}
    >
      <TableCell>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={(_e) =>
            handleNavigateToProject(ticket?.project?._id, ticket?._id)
          }
          sx={{
            margin: 0,
            whiteSpace: 'nowrap',
            minWidth: 'auto',
          }}
        >
          {ticket?.reference}
        </Button>
      </TableCell>
      <TableCell>
        <TicketStatusChip
          status={ticket?.status}
          hasActiveTask={ticket?.hasActiveTask}
          isOpen={ticket?.isOpen}
        />
      </TableCell>
      <TableCell>
        {ticket?.order ? (
          <>
            {ticket?.order?.reference}
            <br />
            {ticket?.order?.status?.name}
          </>
        ) : (
          'N./A.'
        )}
      </TableCell>
      <TableCell>
        <Tooltip placement="top" title={ticket?.contact?.email}>
          <Typography component={'span'}>
            {ticket?.contact?.firstName !== null &&
            ticket?.contact?.lastName !== null
              ? `${ticket?.contact?.firstName} ${ticket?.contact?.lastName}`
              : ticket?.contact?.lastName !== null
                ? `${ticket?.contact?.lastName}`
                : `${ticket?.contact?.email}`}
          </Typography>
        </Tooltip>
      </TableCell>
      <TableCell>{ticket?.contact?.store?.shortName}</TableCell>
      {/* <TableCell>
        <TicketTypeIcon
          ticketType={ticket?.ticketType?.name}
          service={ticket?.service?.code}
        />
      </TableCell> */}
      {/* <TableCell>
        <PriorityFlag priority={ticket?.priority?.name} />
      </TableCell> */}
      <TableCell>{ticket?.messagesCount}</TableCell>
      <TableCell>
        {ticket?.lastMessageAt
          ? new Date(ticket?.lastMessageAt).toLocaleString('fr-FR', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
            })
          : 'Pas de message'}
      </TableCell>
      <TableCell>
        <Tooltip
          placement="left"
          title={
            <Box>
              {new Date(ticket?.message?.sentAt).toLocaleString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
              })}
              <Divider />
              <Typography
                component={'span'}
                sx={{
                  fontSize: '0.7rem',
                  whiteSpace: 'break-spaces',
                }}
              >
                {ticket?.message?.snippet}
              </Typography>
            </Box>
          }
        >
          <Typography
            component={'span'}
            sx={{
              fontSize: '0.9rem',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: '2',
              WebkitBoxOrient: 'vertical',
              width: '450px',
            }}
          >
            {ticket?.message?.snippet}
          </Typography>
        </Tooltip>
      </TableCell>
      <TableCell align="right">
        {service === 'MP' ? (
          <>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleOpenTicketModerationDialog}
            >
              Modérer
            </Button>
          </>
        ) : (
          <>
            {isLoading ? (
              <LinearProgress color="info" sx={{ margin: 1 }} />
            ) : (
              <UserAssignmentAutocomplete
                assignmentId={ticket?.assignedTo?._id}
                setSelectedUser={setSelectedUser}
                selectedUser={selectedUser}
                type={'ticket'}
              />
            )}
          </>
        )}
      </TableCell>
      <TableCell align="right">
        <DashboardSCTicketTableMenu
          ticket={ticket}
          shouldOpenTicketModerationDialog={shouldOpenTicketModerationDialog}
          handleOpenTicketModerationDialog={handleOpenTicketModerationDialog}
          mutate={mutate}
        />
      </TableCell>
    </TableRow>
  );
};

const DashboardSCTicketTable = (props) => {
  const {
    loading,
    validating,
    datas,
    service,
    dashboardData,
    setIsClose,
    setToModerate,
    setSellerType,
    setOrderRef,
    setOrderBy,
    setOrder,
    setAssignedUserTicket,
    limit,
    setLimit,
    page,
    setPage,
    total,
    mutate,
    titleIcon,
  } = props;

  const handleChangePage = useCallback(
    (event, newPage) => {
      setPage(newPage);
    },
    [limit, datas]
  );

  const handleChangeLimit = useCallback(
    (event) => {
      const updatedLimit = parseInt(event.target.value, 10);
      setLimit(updatedLimit);
      setPage(0);
    },
    [datas]
  );

  return (
    <Paper elevation={24} sx={{ width: '100%', mb: 2 }}>
      <DashboardSCTicketTableToolbar
        loading={loading}
        validating={validating}
        service={service}
        titleIcon={titleIcon}
        dashboardData={dashboardData}
        setIsClose={setIsClose}
        setToModerate={setToModerate}
        setSellerType={setSellerType}
        setOrderRef={setOrderRef}
        setAssignedUserTicket={setAssignedUserTicket}
        nb={total}
      />
      <TableContainer>
        <Table sx={{ minWidth: 750 }} size="small">
          <DashboardSCTicketTableHead
            dashboardData={dashboardData}
            setOrderBy={setOrderBy}
            setOrder={setOrder}
          />
          <TableBody>
            {loading || dashboardData.content === 'Tasks' ? (
              <TableRow>
                {headers?.map((h, idx) => (
                  <TableCell key={idx}>
                    <Skeleton
                      key={idx}
                      variant="text"
                      sx={{ fontSize: '2em' }}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ) : datas ? (
              datas?.map((row, index) => {
                return row?.reference ? (
                  <DashboardSCTicketRow
                    key={row?._id}
                    service={service}
                    ticket={row}
                    mutate={mutate}
                  />
                ) : (
                  <TableRow key={index}>
                    {headers?.map((h, idx) => (
                      <TableCell key={idx}>
                        <Skeleton
                          key={idx}
                          variant="text"
                          sx={{ fontSize: '2em' }}
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })
            ) : null}
          </TableBody>
        </Table>
      </TableContainer>
      {datas ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          {validating && <CircularProgress color="info" size={'1.3em'} />}
          <TablePagination
            rowsPerPageOptions={[10]}
            component="div"
            count={total}
            rowsPerPage={limit}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeLimit}
          />
        </Box>
      ) : null}
    </Paper>
  );
};

export default DashboardSCTicketTable;
